







































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ErrorModal from '@/views/error-monitor/error-monitor-details.modal.vue';
import EventErrorService from '@/domain/event/event-error.service';
import EventError from '@/domain/event/event-error.entity';
import ProjectUserStore from '@/domain/project/project-with-members.store';
import EventAggregator from '../../domain/event/event-aggregator.entity';

const ERROR_THRESHOLD = 45;

@Component({
  components: {
    ErrorModal,
  },
})
export default class ErrorList extends Vue {
  @Prop() errors?: EventAggregator[];

  @Prop() header: any;

  @Prop() loading!: boolean;

  @Prop({ type: Array, default: () => [] }) selectedEventErrorIds!: String[];

  private projectsStore = getModule(ProjectUserStore);

  private eventErrorService = new EventErrorService();

  private errorsDetails = [new EventError({})];

  private search?: string;

  dialog?: boolean = false;

  private titleModal: any = '';

  private pagination: any = {
    rowsPerPage: -1,
    sortBy: 'lastDate',
    descending: 'true',
  };

  viewItem(error: EventAggregator) {
    this.dialog = true;
    this.projectsStore.getProject(this.$route.params.projectName)
      .then(project => this.eventErrorService
        .searchAllErrorsDetails(project.id, error.id)
        .then(errorsDetails => this.errorsDetails = errorsDetails));
    this.titleModal = error.description;
  }

  formatLatestError(latestError: string): string {
    if (latestError.length <= ERROR_THRESHOLD) {
      return latestError;
    }
    return `${latestError.substring(0, ERROR_THRESHOLD)}...`;
  }

  closeModal() {
    this.dialog = false;
    this.$emit('updateList');
  }

  onSelect(checked: boolean, error: EventAggregator) {
    let newSelected = [...this.selectedEventErrorIds];
    if (checked) {
      if (!newSelected.some(item => item === error.latestErrorId)) {
        newSelected.push(error.latestErrorId);
      }
    } else {
      newSelected = newSelected.filter(item => item !== error.latestErrorId);
    }
    this.$emit('update:selectedEventErrorIds', newSelected);
  }

  get allSelected(): boolean {
    if (!this.errors || this.errors.length === 0) {
      return false;
    }
    return this.errors.every(item => this.selectedEventErrorIds.includes(item.latestErrorId));
  }

  get hasErrors(): boolean {
    if (!this.errors || this.errors.length === 0) {
      return false;
    }
    return true;
  }

  selectEventErrorIds(item: EventAggregator): boolean {
    return this.selectedEventErrorIds.some(id => id === item.latestErrorId);
  }

  toggleSelectAll(checked: boolean) {
    if (checked) {
      const allIds = this.errors ? this.errors.map(item => item.latestErrorId) : [];
      this.$emit('update:selectedEventErrorIds', allIds);
      return;
    }
    this.$emit('update:selectedEventErrorIds', []);
  }
}
